export const MAIL_CATEGORIES = [
  'paymentConfirmation',
  'promiseToPay',
  'paymentPlanRequest',
  'administrativeChange',
  'questionClarification',
  'documentRequest',
  'dispute',
  'forward',
] as const;

export type MailCategory = (typeof MAIL_CATEGORIES)[number];

export const MAIL_CATEGORY_LABELS: Record<MailCategory, string> = {
  paymentConfirmation: 'EXTERNAL_MAIL.CATEGORY.PAYMENT_CONFIRMATION',
  promiseToPay: 'EXTERNAL_MAIL.CATEGORY.PROMISE_TO_PAY',
  paymentPlanRequest: 'EXTERNAL_MAIL.CATEGORY.PAYMENT_PLAN_REQUEST',
  administrativeChange: 'EXTERNAL_MAIL.CATEGORY.ADMINISTRATIVE_CHANGE',
  questionClarification: 'EXTERNAL_MAIL.CATEGORY.QUESTION_CLARIFICATION',
  documentRequest: 'EXTERNAL_MAIL.CATEGORY.DOCUMENT_REQUEST',
  dispute: 'EXTERNAL_MAIL.CATEGORY.DISPUTE',
  forward: 'EXTERNAL_MAIL.CATEGORY.FORWARD',
};

export const MAIL_CATEGORY_COLORS: Record<MailCategory, string> = {
  paymentConfirmation: 'green',
  promiseToPay: 'green',
  paymentPlanRequest: 'yellow',
  dispute: 'red',
  administrativeChange: 'violet',
  questionClarification: 'violet',
  documentRequest: 'violet',
  forward: 'gray',
};
